import styles from './similarAds.module.scss';

function SimilarAdsContainer({ children }: IChildren) {
  return (
    <section className={styles.similar}>
      <h3>Bien(s) similaire(s) à la vente récemment</h3>

      {children}
    </section>
  );
}

export default SimilarAdsContainer;
